"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @private
 */
exports.PAYMENTS_USER_ENDPOINT = {
    postPaymentMethod: '/payments/{{version}}/users/{{userUuid}}/payment-methods',
    patchPaymentMethod: '/backoffice/payments/{{version}}/users/{{userUuid}}/payment-methods/{{methodUuid}}',
    putLinkPaymentMethodToUser: '/payments/{{version}}/users/{{userProfileUuid}}/link-payment-method',
    getUserPaymentMethods: '/payments/{{version}}/users/{{userUuid}}/payment-methods',
};
